import { ErrorIcon } from '../Icons';
import classNames from 'classnames';

interface FormErrorProps {
  errorMessage?: string;
  margin?: string;
}

export const FormError = ({
  errorMessage = 'Something went wrong, please try again.',
  margin = 'mt-4',
}: FormErrorProps) => {
  return (
    <div
      className={classNames(margin, 'text-xs text-red-600 flex items-center')}
    >
      <ErrorIcon className="mr-1 size-4" />
      <p>{errorMessage}</p>
    </div>
  );
};
